"use strict";


class AuszahlungsbetragEditController {
  /*@ngInject*/
  constructor($q, $scope, i18n, moment) {
    this.$q = $q;
    this.gettext = i18n.gettext;
    this.auszahlung = $scope.extras.auszahlung;
    this.az_betrag = this.auszahlung.az_betrag;
    this.az_datum_ausgezahlt = this.auszahlung.az_datum_ausgezahlt || moment().format("YYYY-MM-DD");
    this.saveAuszahlungsbetrag = this.saveAuszahlungsbetrag.bind(this);
  }

  saveAuszahlungsbetrag() {
    const defer = this.$q.defer();
    this.auszahlung.saveAuszahlungsbetrag(this.az_betrag, this.az_datum_ausgezahlt).then(response => {
      defer.resolve(response);
    }, errors => {
      this.errors = errors.data;
      defer.reject();
    });

    return defer.promise;
  }
}

export default AuszahlungsbetragEditController;
